import React from 'react';
import axios from 'axios';

import ButtonReceitas from './buttonReceitas'

class ReceitasExib extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            RecipesArray:[]
        }
        this.getRecipes = this.getRecipes.bind(this)
    }
    componentDidMount(){
        this.getRecipes()
    }
    getRecipes(){
        axios.get('https://infinite-thicket-90676.herokuapp.com/receitanews')
        .then(res => {
            const List = res.data;
            this.setState({RecipesArray: List});
        })
        .catch(err => {
            console.log(err)
        })
        .finally(() => {
            console.log(this.state.RecipesArray)
        })
    }
    deleteRecipes(receitas){
        if(window.confirm("Tem certeza que deseja excluir essa receita?")){
            axios.delete(`https://infinite-thicket-90676.herokuapp.com/receitanews/${receitas.id}`)
                .then(() => window.location.reload())   
        }
    }
    render(){
        return(
            <div className="container">
            <div className="col-md-12 text-center">
            <p className="textoP">VEJA POSSÍVEIS </p>
            <h1 className="textoH">Receitas com nossos produtos</h1>
            </div>
            <div className="row">
                {this.state.RecipesArray.reverse().map((receitas, index) => {
                    return(
                        <div key={index} style={{ marginTop: 50, marginBottom:50 }} className="col-md-4">
                        <div className="card-deck">
                            <div key={receitas.id} className="card">
                                <img className="card-img-top" style={{ height: 265 }} src={receitas.imagem_url} alt={receitas.nome}></img>
                                <div className="card-body">
                                <h5 className="card-title">{receitas.nome}</h5>
                                    <p className="card-text">{receitas.descricao}</p>
                                </div>
                                <div style={{ marginLeft:1, marginRight:0 }} className="card-footer row align-items-center justify-content-between">
                                    <i className="fas fa-user-alt"></i>
                                    <p className="textoReceitas">{receitas.qtd_pessoas}</p>

                                    <i  className="fas fa-stopwatch"></i>
                                    <p className="textoReceitas">{receitas.tempo}</p>

                                    <i  className="fas fa-fire-alt"></i>
                                    <p className="textoReceitas">{receitas.calorias}</p>

                                    <ButtonReceitas
                                    tituloModal={receitas.nome}
                                    index={index}
                                    descricaoModal = 
                                    {
                                        <div className="container-fluid">
                                            <img style={{ width:'100%' }} src={receitas.imagem_url} alt={receitas.nome}></img>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h1>Ingredientes</h1>
                                                </div>
                                                <div className="col-md-12">
                                                    <p>{receitas.ingredientes}</p>
                                                </div>
                                                <div className="col-md-12">
                                                    <h1>Modo de preparo</h1>
                                                </div>
                                                <div className="col-md-12">
                                                    <p>{receitas.como_fazer}</p>
                                                </div>
                                            </div>
                                            <div style={{width:'100%'}} className="card-footer row align-items-center">
                                                <i style={{ marginLeft:'6%' }} className="fas fa-user-alt"></i>
                                                <p className="textoReceitas">{receitas.qtd_pessoas}</p>

                                                <i style={{ marginLeft:35 }} className="fas fa-stopwatch"></i>
                                                <p className="textoReceitas">{receitas.tempo}</p>

                                                <i style={{ marginLeft:35 }} className="fas fa-fire-alt"></i>
                                                <p className="textoReceitas">{receitas.calorias}</p>
                                            </div>
                                        </div>
                                    }
                                    />    
                                </div>
                            </div>
                        </div>
                    </div>
                    )
                })}
            </div>
            </div>
        );
    }
}

export default ReceitasExib;